import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Scrollbar } from 'swiper';

import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import ArrowIcon from './ArrowIcon';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';

export default function Protection() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();

    const lists = [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767679125881-3f6oj7-compressed-Frame%202094654860.jpg',
            title: t('secM_list1_desc'),
            learnMore: 'https://blog.ecoflow.com/us/battery-backup-vs-generator',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767679141478-vz4ar9-compressed-Frame%202094654861.jpg',
            title: t('secM_list2_desc'),
            learnMore: 'https://blog.ecoflow.com/us/build-home-battery-backup-system/',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767679154300-8oxehc-compressed-Frame%202094654937.jpg',
            title: t('secM_list3_desc'),
            learnMore: 'https://blog.ecoflow.com/us/use-home-backup-battery-system-without-solar-power/',
        },
    ];

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
        rootMargin: '-20% 0px',
    });
    return (
        <div ref={ref} className={`${styles.Protection} GtmModuleData-section`}>
            <div className="pb-layout">
                <div className={cn(isVisible, 'power-backup-title fade-up')}>{t('secM_title')}</div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    spaceBetween={20}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 'auto',
                        snapOnRelease: true,
                    }}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                >
                    {lists?.map((card, k: number) => (
                        <SwiperSlide
                            style={{ '--animate-delay': `${(k + 2) * 0.15}s` } as React.CSSProperties}
                            className={cn(isVisible, `swiper-item item-${k + 1} fade-up`)}
                            key={k}
                        >
                            <EcoImg pc={card?.pc} />
                            <div className="bottom-wrapper">
                                <div className="bottom-desc">{card.title}</div>
                                <div className="bottom-learnMore" onClick={() => window.open(card.learnMore, '_blank')}>
                                    {t('common_card_more')}
                                    <ArrowIcon />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" />
                    <div className="swiper-button-next" />
                </Swiper>
            </div>
        </div>
    );
}
